import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'

const AuthenticationStore = {
  state: {
    user: null,
    permissions: []
  },
  getters,
  mutations,
  actions
}

export default AuthenticationStore
